package com.patronat.top.library.media.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.error.AppErrorCode
import com.patronat.top.library.media.domain.command.UploadImageCommand
import com.patronat.top.library.media.domain.models.FileRegistration
import com.patronat.top.library.media.domain.repository.MediaRepository




class UploadImageUseCase(
    private val repository: MediaRepository,
    dispatcher: DispatcherProvider
) : BaseUseCase<UploadImageCommand, DomainResult<FileRegistration>>(dispatcher.io) {

    override suspend fun doWork(command: UploadImageCommand): DomainResult<FileRegistration> {
        val preparedUpload = MediaUploadPreprocessor.prepare(
            file = command.file,
            type = command.type,
            mimeType = command.mimeType
        ) ?: return DomainResult.Error(
            type = AppErrorCode.INVALID_MEDIA_TYPE,
            message = "Не вдалося обробити зображення"
        )

        return repository.uploadImage(
            file = preparedUpload.file,
            type = command.type,
            mimeType = preparedUpload.mimeType,
            onProgress = command.onProgress
        )
    }
}
